var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165 82.5C165 128.063 128.063 165 82.5 165C36.9365 165 0 128.063 0 82.5C0 36.9365 36.9365 0 82.5 0C128.063 0 165 36.9365 165 82.5ZM17.3352 82.5C17.3352 118.49 46.5105 147.665 82.5 147.665C118.49 147.665 147.665 118.49 147.665 82.5C147.665 46.5105 118.49 17.3352 82.5 17.3352C46.5105 17.3352 17.3352 46.5105 17.3352 82.5Z",
    fill: "#D4E3FF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165 82.5C165 71.6659 162.866 60.938 158.72 50.9286C154.574 40.9193 148.497 31.8245 140.836 24.1637C133.175 16.5029 124.081 10.4259 114.071 6.27993C104.062 2.13392 93.334 -1.76509e-06 82.5 0L82.5 17.3352C91.0575 17.3352 99.5313 19.0208 107.437 22.2956C115.344 25.5704 122.527 30.3704 128.578 36.4215C134.63 42.4726 139.43 49.6564 142.704 57.5625C145.979 65.4687 147.665 73.9424 147.665 82.5H165Z",
    fill: "#2773FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.54e337163774111c41778c7e7cc1a5d3.svg";
export { ForwardRef as ReactComponent };